import React from 'react';

import SeparatorBar from '../../nutrition-label/components/SeparatorBar';
import NutrientRowNew from '../../nutrition-label/components/NutrientRowNew';

import { useGetBasicUomEnum } from 'hooks';
import { getUomTypesAbbreviations } from '../../nutrition-label/DailyValueConstants';
import { WrapperFactsPanel } from './overlay/WrapperNutrient';

import { renderContainerDescriptor } from '../components/utils';

import './VerticalLabel.less';

function VerticalLabel({ label, nutrients, compareValue }) {
  const { basicUomProperties } = useGetBasicUomEnum();

  const servingPerContainerDescriptor = renderContainerDescriptor(
    label?.servingPerContainerDescriptor
  );

  return (
    <div className='nutrition-facts'>
      <h1 className='nutrition-facts__label'>Nutrition Facts</h1>
      <SeparatorBar />
      <div className='nutrition-facts__servingsize'>
        {label?.numberOfServingsPerPackage != null ? (
          <WrapperFactsPanel
            label={['numberOfServingsPerPackage']}
            currentValue={label}
            originValue={compareValue}
          >
            <div className='nutrition-facts__servings-per-container'>
              <p style={{ textTransform: 'capitalize', marginBottom: 0 }}>
                {servingPerContainerDescriptor ? (
                  <span>{servingPerContainerDescriptor}&nbsp;</span>
                ) : null}
                {label?.numberOfServingsPerPackage} servings per container
              </p>
            </div>
          </WrapperFactsPanel>
        ) : null}
        <WrapperFactsPanel
          label={[
            'servingSizeDescription',
            'servingSize',
            'servingSizeMeasurement',
          ]}
          currentValue={label}
          originValue={compareValue}
        >
          <div className='nutrition-facts__servingsize-bold'>
            <div>Serving size</div>
            <div>
              {label?.servingSizeDescription}{' '}
              {label?.servingSize &&
                `(${label?.servingSize} ${getUomTypesAbbreviations(
                  basicUomProperties,
                  label?.servingSizeMeasurement
                )})`}
            </div>
          </div>
        </WrapperFactsPanel>
      </div>
      <SeparatorBar height={7} />
      <WrapperFactsPanel
        label={['calories']}
        currentValue={label}
        originValue={compareValue}
      >
        <div className='nutrition-facts__calories-container'>
          <div>
            <div className='nutrition-facts__calories'>Amount Per Serving</div>
            <div className='nutrition-facts__calories_new-calories'>
              Calories
            </div>
          </div>

          <div className='nutrition-facts__calories_numeric'>
            {label?.calories}
          </div>
        </div>
      </WrapperFactsPanel>
      <SeparatorBar height={3} />
      <div className='nutrition-facts__dv-heading'>% Daily Value*</div>
      {nutrients?.map((nutrient) => {
        return <NutrientRowNew nutrient={nutrient} />;
      })}

      {label?.ingredientNotice && (
        <>
          <SeparatorBar height={3} />
          <div className='nutrition-facts__ingredient-notice'>
            <WrapperFactsPanel
              label={['ingredientNotice']}
              currentValue={label}
              originValue={compareValue}
            >
              {label?.ingredientNotice}
            </WrapperFactsPanel>
          </div>
        </>
      )}
      <SeparatorBar height={3} />
      <div className='nutrition-facts__footnote'>
        {!!label?.fdaLabelFootNote && (
          <>
            <WrapperFactsPanel
              label={['fdaLabelFootNote']}
              currentValue={label}
              originValue={compareValue}
            >
              <span>* {label?.fdaLabelFootNote}</span>
            </WrapperFactsPanel>
          </>
        )}
      </div>
    </div>
  );
}

export default VerticalLabel;
